import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryPurchaseOrderDetailsResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setPurchaseOrderDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const usePurchaseOrderDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (po_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${INVENTORY_MODULE?.PURCHASE_ORDER_DETAILS?.baseURL}?po_id=${po_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderDetailsResponse>) => {
            if (res.data.status === true) {
              dispatch(setPurchaseOrderDetails(res.data.data));
            } else {
              dispatch(setPurchaseOrderDetails(null));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        dispatch(setPurchaseOrderDetails(null));
        if (axios.isAxiosError(error)) {
          captureError(error)
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute };
};
